






















































import { Popup, Form, Field, Button, Toast } from "vant";
import PopupHeader from "@/views/h5-page/account/Component/PopupHeader.vue";

export default {
  name: "AddAccount",
  components: {
    PopupHeader,
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    enable(): boolean {
      const account = (this as any).account;
      const password = (this as any).password;
      return (
        account !== null &&
        account.length > 0 &&
        password !== null &&
        password.length > 0
      );
    }
  },
  data() {
    return {
      account: "",
      password: "",
      error: ""
    };
  },
  methods: {
    close() {
      (this as any).$emit("close");
    },
    clearAccount() {
      (this as any).account = "";
    },
    clearPassword() {
      (this as any).password = "";
    },
    submit() {
      Toast.resetDefaultOptions();
      const data = {
        account: (this as any).account,
        password: (this as any).password
      };
      (this as any).$apis
        .addAccount(data)
        .then(res => {
          // Toast("添加成功");
          (this as any).account = "";
          (this as any).password = "";
          this.close();
          setTimeout(() => {
            (this as any).$emit("success");
          }, 500);
        })
        .catch(e => {
          
        });
    }
  }
};
